/* eslint-disable camelcase */
import {
  createSelector,
} from 'reselect';

import {
  getResourceMap,
  getResourceMappedList,
} from './resources';

import {
  invoicesSelector,
} from './payments';

export const getIntents = createSelector(
  [
    getResourceMappedList('paymentIntents'),
    invoicesSelector,
    getResourceMap('products'),
  ],
  (
    intents,
    invoices,
    productsMap,
  ) => intents.map(
    intent => ({
      ...intent,
      product_data: productsMap[Number(intent.metadata?.product_id)],
      invoice_data: invoices.find(
        i => i.id === intent.invoice,
      ),
    }),
  ),
);
